export const config = {
  env: process.env.NODE_ENV === "production" ? "production" : "development",
  isProd: process.env.NODE_ENV === "production",
  isDev: process.env.NODE_ENV !== "production",
  apiBaseUrl: process.env.BUN_PUBLIC_R365_API_BASE_URL ?? "https://api.dev.rglobal365.com/api",
  walletApiUrl: process.env.BUN_PUBLIC_R365_WALLET_API_URL ?? "https://api.dev.rglobal365.com/wallet",
  onboardingApiUrl:
    process.env.BUN_PUBLIC_R365_ONBOARDING_API_URL ?? "https://api.dev.rglobal365.com/onboarding/api/v1",
  appName: "Remesas 365 — Backoffice",
  sessionKey: "r365_bo_session",
} as const;
